import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { updateField } from "@joandvgv/vuex-map-fields";
import Vue from "vue";
export const SET_AUTOMATION_DATA = "SET_AUTOMATION_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_SAVING = "SET_SAVING";
export const SET_SAVING_STATUS = "SET_SAVING_STATUS";
export const SET_CURRENT_AUTOMATION = "SET_CURRENT_AUTOMATION";
export const CLEAR_CURRENT_AUTOMATION = "CLEAR_CURRENT_AUTOMATION";
export const SET_EDITING = "SET_EDITING";
export const SET_DELETING = "SET_DELETING";
export const CLEAR_AUTOMATION_TO_DELETE = "CLEAR_AUTOMATION_TO_DELETE";
export const SET_EMAILS_SYNCED = "SET_EMAILS_SYNCED";
export const SET_EMAIL_SIGNATURE = "SET_EMAIL_SIGNATURE";
export const TOGGLE_TRIGGER_COLLAPSE = "TOGGLE_TRIGGER_COLLAPSE";
export const SET_TRIGGER_COLLAPSE = "SET_TRIGGER_COLLAPSE";
export const SET_APPLICATION_AUTOMATIONS = "SET_APPLICATION_AUTOMATIONS";
export const SET_DEFAULT_LIST = "SET_DEFAULT_LIST";
export const SET_DEFAULT_EMAIL = "SET_DEFAULT_EMAIL";
export const SET_AUTOMATION_SCHEDULED_EMAILS = "SET_AUTOMATION_SCHEDULED_EMAILS";
export const SUPPRESS_CAMPAIGN_SCHEDULED_EMAIL = "SUPPRESS_CAMPAIGN_SCHEDULED_EMAIL";
export const SET_AUTOMATION_TEMPLATE_DATA = "SET_AUTOMATION_TEMPLATE_DATA";
export const SET_AUTOMATION_SUBJECT_DATA = "SET_AUTOMATION_SUBJECT_DATA";
export const SET_AUTOMATION_STATISTICS = "SET_AUTOMATION_STATISTICS";
export const CLEAR_AUTOMATION_ROUTE_PARAMS = "CLEAR_AUTOMATION_ROUTE_PARAMS";
export const SET_APPLICATION_AUTOMATION_STATUS = "SET_APPLICATION_AUTOMATION_STATUS";
export const SET_APPLICATION_AUTOMATION_DATA = "SET_APPLICATION_AUTOMATION_DATA";
export const SET_CHANGING_AUTOMATION_STATUS = "SET_CHANGING_AUTOMATION_STATUS";
export const TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID = "TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID";
export const SET_DOCUMENT_REQUEST_AUTOMATIONS = "SET_DOCUMENT_REQUEST_AUTOMATIONS";
export const SET_DOCUMENT_REQUEST_AUTOMATION_SCHEMA = "SET_DOCUMENT_REQUEST_AUTOMATION_SCHEMA";
export const SET_DOCUMENT_REQUEST_AUTOMATION_RULE = "SET_DOCUMENT_REQUEST_AUTOMATION_RULE";
export const SET_DOCUMENT_REQUEST_AUTOMATION_ACTIVE = "SET_DOCUMENT_REQUEST_AUTOMATION_ACTIVE";
export const REMOVE_DOCUMENT_CLASSIFICATION = "REMOVE_DOCUMENT_CLASSIFICATION";
export const ADD_DOCUMENT_CLASSIFICATION = "ADD_DOCUMENT_CLASSIFICATION";
export const EDIT_DOCUMENT_CLASSIFICATION = "EDIT_DOCUMENT_CLASSIFICATION";
export const TOGGLE_DOCUMENT_REQUEST_EDIT_MODE = "TOGGLE_DOCUMENT_REQUEST_EDIT_MODE";
export const SET_AUTOMATION_DATA_LOADED = "SET_AUTOMATION_DATA_LOADED";
const mutations = {
  updateField,
  [SET_AUTOMATION_DATA]: (state, data) => {
    state.automationData = data;
  },
  [SET_LOADING]: (state, value) => {
    state.loading = value;
  },
  [SET_AUTOMATION_DATA_LOADED]: (state, value) => {
    state.automationsDataLoaded = value;
  },
  [SET_SAVING]: (state, value) => {
    state.saving = value;
  },
  [SET_SAVING_STATUS]: (state, value) => {
    state.savingStatus = value;
  },
  [TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID]: (state, id) => {
    Vue.set(state.automationData.entities.automation[id], "enabled", !state.automationData.entities.automation[id].enabled);
  },
  [SET_CURRENT_AUTOMATION]: (state, value) => {
    Vue.set(state, "currentAutomation", _objectSpread({
      triggerArguments: value["trigger-arguments"],
      actionArguments: value["action-arguments"]
    }, value));
  },
  [CLEAR_CURRENT_AUTOMATION]: state => {
    state.currentAutomation = {
      trigger: {},
      triggerArguments: {},
      action: {},
      actionArguments: {},
      id: null,
      shared: false
    };
  },
  [SET_EDITING]: (state, value) => {
    state.editing = value;
  },
  [SET_DELETING]: (state, value) => {
    state.deleting = value;
  },
  [CLEAR_AUTOMATION_TO_DELETE]: state => {
    state.automationToDelete = {
      trigger: {},
      triggerArguments: {},
      action: {},
      actionArguments: {},
      id: null,
      shared: false
    };
  },
  [SET_EMAILS_SYNCED]: (state, value) => {
    state.emailsSynced = value;
  },
  [SET_EMAIL_SIGNATURE]: (state, value) => {
    state.emailSignature = value;
  },
  [SET_TRIGGER_COLLAPSE]: (state, {
    key,
    value
  }) => {
    state.collapseTriggers = _objectSpread(_objectSpread({}, state.collapseTriggers), {}, {
      [key]: value
    });
  },
  [TOGGLE_TRIGGER_COLLAPSE]: (state, key) => {
    state.collapseTriggers = _objectSpread(_objectSpread({}, state.collapseTriggers), {}, {
      [key]: !state.collapseTriggers[key]
    });
  },
  [SET_APPLICATION_AUTOMATIONS]: (state, data) => {
    state.appAutomationData = data;
  },
  [SET_DEFAULT_LIST]: (state, list) => {
    state.defaultList = list;
  },
  [SET_DEFAULT_EMAIL]: (state, email) => {
    state.defaultMarketingEmail = email;
  },
  [SET_AUTOMATION_SCHEDULED_EMAILS]: (state, {
    id,
    recipients
  }) => {
    Vue.set(state.appAutomationData.entities.automation[id], "recipients", recipients);
  },
  [SET_AUTOMATION_STATISTICS]: (state, {
    id,
    statistics
  }) => {
    Vue.set(state.appAutomationData.entities.automation[id]["action-arguments"], "statistics", statistics);
  },
  [SET_APPLICATION_AUTOMATION_STATUS]: (state, {
    id,
    status
  }) => {
    state.appAutomationData.entities.automation[id]["action-arguments"].status = status;
  },
  [SET_APPLICATION_AUTOMATION_DATA]: (state, {
    id,
    details
  }) => {
    const currentActionArguments = state.appAutomationData.entities.automation[id]["action-arguments"];
    state.appAutomationData.entities.automation[id]["action-arguments"] = _objectSpread(_objectSpread({}, currentActionArguments), details);
  },
  [SUPPRESS_CAMPAIGN_SCHEDULED_EMAIL]: (state, {
    automationId,
    scheduledEmailId
  }) => {
    const automationRecipients = state.appAutomationData.entities.automation[automationId].recipients;
    const currentRecipient = _findInstanceProperty(automationRecipients).call(automationRecipients, recipient => recipient.id === scheduledEmailId);
    currentRecipient.suppressed = !currentRecipient.suppressed;
  },
  [SET_AUTOMATION_TEMPLATE_DATA]: (state, {
    automationId,
    templateData
  }) => {
    const currentAutomation = state.appAutomationData.entities.automation[automationId];
    currentAutomation["action-arguments"] = _objectSpread(_objectSpread({}, currentAutomation["action-arguments"]), templateData);
  },
  [SET_AUTOMATION_SUBJECT_DATA]: (state, {
    automationId,
    subjectData
  }) => {
    const currentAutomation = state.appAutomationData.entities.automation[automationId];
    currentAutomation["action-arguments"] = _objectSpread(_objectSpread({}, currentAutomation["action-arguments"]), subjectData);
  },
  [CLEAR_AUTOMATION_ROUTE_PARAMS]: (state, route) => {
    route.params.editMode = false;
    route.params.openAutomation = null;
    route.params.openTrigger = null;
    route.params.subjectData = null;
    route.params.templateData = null;
  },
  [SET_CHANGING_AUTOMATION_STATUS]: (state, loading) => {
    state.changingAutomationStatus = loading;
  },
  [SET_DOCUMENT_REQUEST_AUTOMATIONS]: (state, documentRequestAutomations) => {
    Vue.set(state, "documentRequestAutomations", documentRequestAutomations);
  },
  [SET_DOCUMENT_REQUEST_AUTOMATION_SCHEMA]: (state, schema) => {
    Vue.set(state, "documentRequestAutomationSchema", schema);
  },
  [SET_DOCUMENT_REQUEST_AUTOMATION_RULE]: (state, {
    documentRequestRuleId,
    documentRequestRule
  }) => {
    Vue.set(state.documentRequestAutomations.byId[documentRequestRuleId], "documentRequestRule", documentRequestRule);
  },
  [SET_DOCUMENT_REQUEST_AUTOMATION_ACTIVE]: (state, {
    documentRequestRuleId,
    active
  }) => {
    Vue.set(state.documentRequestAutomations.byId[documentRequestRuleId], "active", active);
  },
  [REMOVE_DOCUMENT_CLASSIFICATION]: (state, {
    documentRequestRuleId,
    documentIndex
  }) => {
    Vue.delete(state.documentRequestAutomations.byId[documentRequestRuleId].documentRequestRule.documents, documentIndex);
  },
  [ADD_DOCUMENT_CLASSIFICATION]: (state, {
    documentRequestRuleId,
    documentClassification
  }) => {
    const documents = state.documentRequestAutomations.byId[documentRequestRuleId].documentRequestRule.documents;
    Vue.set(state.documentRequestAutomations.byId[documentRequestRuleId].documentRequestRule, "documents", [...documents, documentClassification]);
  },
  [EDIT_DOCUMENT_CLASSIFICATION]: (state, {
    documentRequestRuleId,
    documentIndex,
    documentClassification
  }) => {
    const document = state.documentRequestAutomations.byId[documentRequestRuleId].documentRequestRule.documents[documentIndex];
    Vue.set(state.documentRequestAutomations.byId[documentRequestRuleId].documentRequestRule.documents, documentIndex, _objectSpread(_objectSpread({}, document), documentClassification));
  },
  [TOGGLE_DOCUMENT_REQUEST_EDIT_MODE]: (state, {
    documentRequestRuleId,
    editing
  }) => {
    var _state$documentReques;
    const currentState = (_state$documentReques = state.documentRequestEditMode[documentRequestRuleId]) != null ? _state$documentReques : false;
    Vue.set(state.documentRequestEditMode, documentRequestRuleId, editing != null ? editing : !currentState);
  }
};
export default mutations;